import { Box, Button, Card, CardActions, CardContent, Chip, CircularProgress, IconButton, Stack, Typography } from "@mui/material"
import { FormMovimentacao } from "./formMov"
import { Movimentacao, ItemMov } from "../../mov.model";
import { ClienteActions } from "../../../cliente/cliente.model";
import { CardListItemMov } from "./cardsItem";
import { formatMoney, getNewId } from "../../../../services/utils";
import { Item, TabelaPrecoItem } from "../../../../data.types";
import ItemSelect, { ViewItemSelectModal } from "../../../item/view/item.select";
import { useCallback, useState, useTransition } from "react";
import { ItemActions } from "../../../item/item.model";
import { AttachFile, Discount, Payments, Task } from "@mui/icons-material";
import { FornecedorActions } from "../../../fornecedor/forn.model";
import { MeioPagActions } from "../../../meioPag/meiopg.model";
import { FuncionarioActions } from "../../../funcionario/funcionario.model";
import { contasController } from "../../../contas/contas.controll";
import { CadastroContasModal, handleShowCadContasModal } from "../../../contas/view/contas.list";

interface TempVendasProps {
    clienteActions: ClienteActions;
    fornecedorActions: FornecedorActions;
    funcionarioActions: FuncionarioActions;
    meioPagActions: MeioPagActions;
    itemActions: ItemActions;
    mutatorLocal: (value: any, field: string) => void;
    mov: Movimentacao;
    showDescontoModal: boolean;
    setShowDescontoModal: (value: boolean) => void;
}


interface CardFormularioProps extends TempVendasProps {
    setShowMovItem: (value: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }) => any;
}
const CardFormulario = (props: CardFormularioProps) => {
    const { clienteActions, mutatorLocal, mov, showDescontoModal, setShowDescontoModal, setShowMovItem, fornecedorActions, meioPagActions, funcionarioActions } = props;
    const [transition, startStransition] = useTransition()

    const finalizar = async () => {
        const getDataVencimento = (): string => {
            const data = new Date()
            data.setDate(data.getDate() + 30)
            return data.toISOString()
        }
        let findGerarConta = mov.fechamento.pagamentos.find(v => v.gerar_titulo)
        if (findGerarConta !== undefined) {
            //setShowMsg("Genrando conta a pagar...","info")
            startStransition(async () => {
                let resp = await contasController.novaConta({
                    tipo: "receber",
                    pessoa: {
                        _id: mov.pessoa._id,
                        nome: mov.pessoa.nome
                    },
                    movimentacao: {
                        _id: mov._id,
                        codigo: mov.codigo,
                    },
                    descricao: `Nota gerada pela movimentação de ${mov.tipo_mov.descricao} N° ${mov.codigo}`,
                    valor: findGerarConta.valor,
                    data_venc: getDataVencimento()
                })
                if (resp.status === "ok") {
                    findGerarConta._id_conta = resp.row._id,
                        mutatorLocal(mov.fechamento.pagamentos, "meioPagUp")
                    //setShowMsg("Conta a receber gerada com sucesso!","info")
                }

            })
        }
        mutatorLocal("FINALIZADO", "situacao")
    }    

    const addItem = (item: Item,tabela:TabelaPrecoItem, fast?: boolean) => {
        //let valor = mov.pessoa.revenda ? item.preco_ata : item.preco_var;
        let valor = tabela.valor;
        let newItemMov: ItemMov = {
            _id: getNewId(),
            item: {
                _id:item._id,
                codigo:item.codigo,
                descricao:item.descricao,
                tabela_preco:tabela,
                info_dt_validade:item.info_dt_validade
            },
            qt: 0,
            valor: valor,
            total: 0,
            ano_validade: undefined,
        }
        setShowMovItem({ item: newItemMov, show: true, operation: "itemMovAdd" });
    }


    return (
        <Card sx={{ display: "flex", flex: 1, flexDirection: "column", justifyContent: "space-between", padding: 1 }}>
            <FormMovimentacao
                clienteActions={clienteActions}
                fornecedorActions={fornecedorActions}
                funcionarioActions={funcionarioActions}
                mutatorLocal={mutatorLocal}
                showDescontoModal={showDescontoModal}
                setShowDescontoModal={setShowDescontoModal}
                mov={mov}
                fieldShow={["codigo", "pessoa.nome", "created_at", "situacao", "fechamento.subtotal", "fechamento.descontos", "fechamento.total", "obs"]} // Exemplo de campos a serem exibidos
                fieldDisabled={["codigo","fechamento.subtotal", "fechamento.descontos", "fechamento.total"]} // Exemplo de campos a serem exibidos
            />
            <ViewItemSelectModal
                handleItemSelect={(prop) => addItem(prop.item,prop.tabela, false)}
                needTabPreco
                //tabela={mov.pessoa.revenda?"ATACADO":"VAREJO"}
            />
            <CardContent sx={{ display: "flex", flex: 1, flexDirection: "column" }}>
                {mov.fechamento.pagamentos.length > 0 && (
                    <Typography variant="subtitle1" color="textDisabled">Formas de Pagamento</Typography>
                )}
                <Stack flexDirection={"row"} justifyContent={"space-between"}>
                    {mov.fechamento.pagamentos.map((mp, idx) => {
                        if (mp._id_conta) {
                            return (
                                <Box key={idx}>
                                    <Chip
                                        label={mp.descricao + ": " + formatMoney(mp.valor)}
                                        size="small"
                                        variant="outlined"
                                        color="primary"
                                        onClick={() => { }}
                                        onDelete={() => mutatorLocal(mp, "meioPagRem")}
                                    />
                                    <Button 
                                        title="Visualizar conta a receber" 
                                        variant="text" 
                                        size="small" 
                                        startIcon={<AttachFile />}
                                        onClick={()=>handleShowCadContasModal(true,mp._id_conta)}
                                    >
                                        Conta
                                    </Button>
                                </Box>
                            )
                        }
                        return (
                            <Chip
                                key={idx}
                                label={mp.descricao + ": " + formatMoney(mp.valor)}
                                size="small"
                                variant="outlined"
                                color="primary"
                                onClick={() => { }}
                                onDelete={() => mutatorLocal(mp, "meioPagRem")}
                            />
                        )                        
                    })}
                </Stack>
                {mov.fechamento.pagamentos.length > 0 && (mov.fechamento.pagamentos.map(mp => mp.valor).reduce((a, b) => a + b, 0) !== mov.fechamento.total) && (
                    <Typography variant="caption" color="error">O total de pagamento esta divergente!</Typography>
                )}
            </CardContent>
            <CadastroContasModal />
            <CardActions sx={{ display: "flex", justifyContent: "end" }} >
                <Stack display={"flex"} direction={"row"} spacing={1} justifyContent={"end"}>
                    <IconButton
                        title="Informar desconto"
                        onClick={() => setShowDescontoModal(true)}
                        disabled={mov.situacao === "FINALIZADO" || mov.fechamento.total === 0}
                    >
                        <Discount />
                    </IconButton>                    
                    <IconButton
                        title="Adicionar meio de pagamento"
                        disabled={mov.fechamento.total === 0}
                        onClick={() => meioPagActions.setShowSelectModal(true)}
                    >
                        <Payments />
                    </IconButton>

                    <IconButton
                        title="Finalizar a movimentação"
                        onClick={() => finalizar()}
                        disabled={(mov.itens.length === 0 || mov.fechamento.pagamentos.length === 0)}
                    >
                        {transition ? (
                            <CircularProgress />
                        ) : (
                            <Task />
                        )}

                    </IconButton>                    
                </Stack>
            </CardActions>
        </Card>
    )
}

const BlockLeft = (props: CardFormularioProps) => {
    return (
        <Stack spacing={2} sx={{ display: "flex", flex: 5, flexDirection: "column", }}>
            <CardFormulario {...props} />
        </Stack>
    )
}

interface BlockRightProps extends TempVendasProps {
    setShowMovItem: (value: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }) => any;
    showMovItem: { item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }
}

const BlockRight = (props: BlockRightProps) => {
    const { mov, mutatorLocal, setShowMovItem, showMovItem, itemActions } = props;

    return (
        <Stack spacing={1} sx={{ display: "flex", flex: 7, flexDirection: "column", }}>
            <CardListItemMov
                mov={mov}
                mutatorLocal={mutatorLocal}
                showMovItem={showMovItem}
                setShowMovItem={setShowMovItem}
                showButtonNew={true}
                handleButtonNew={() => {
                    itemActions.setShowSelectModal(true)
                    //itemActions.read()
                }}

            />
        </Stack>
    )
}

export const TemplateVenda = (props: TempVendasProps) => {
    const [showMovItem, setShowMovItem] = useState<{ item: ItemMov, show: boolean, operation: "itemMovAdd" | "itemMovUpd" | "" }>({ item: {} as ItemMov, show: false, operation: "" })
    return (
        <Stack sx={{ display: "flex", flex: 1, flexDirection: "row" }}>
            <BlockLeft
                clienteActions={props.clienteActions}
                fornecedorActions={props.fornecedorActions}
                funcionarioActions={props.funcionarioActions}
                meioPagActions={props.meioPagActions}
                mutatorLocal={props.mutatorLocal}
                mov={props.mov}
                showDescontoModal={props.showDescontoModal}
                setShowDescontoModal={props.setShowDescontoModal}
                setShowMovItem={setShowMovItem}
                itemActions={props.itemActions}
            />
            <BlockRight
                clienteActions={props.clienteActions}
                fornecedorActions={props.fornecedorActions}
                funcionarioActions={props.funcionarioActions}
                meioPagActions={props.meioPagActions}
                mutatorLocal={props.mutatorLocal}
                mov={props.mov}
                showDescontoModal={props.showDescontoModal}
                setShowDescontoModal={props.setShowDescontoModal}
                setShowMovItem={setShowMovItem}
                showMovItem={showMovItem}
                itemActions={props.itemActions}
            />
        </Stack>
    )
}